import React, { useCallback, useState } from 'react';
import classNames from 'classnames';

import { Switch } from '@common/ui/general';
import profileAPI from '@profile/api/profile';

function ToggleProfile({ defaultOpen = true, column = true }) {
  const [open, setOpen] = useState(defaultOpen);

  const toggleOpen = useCallback(
    async () => {
      setOpen(isOpen => !isOpen);
      await profileAPI.toggleProfileVisibility(open);
    },
    [open],
  );

  return (
    <div className={classNames(
      'toggle-profile',
      { 'toggle-profile--row': !column },
    )}
    >
      <div className="toggle-profile__row toggle-profile__switch-container">
        <span className="toggle-profile__title">
          Public Profile
        </span>
        <Switch onChange={toggleOpen} checked={open} activeColor="#02ce68" />
      </div>
      <div className="toggle-profile__row">
        <span className="toggle-profile__info">
          By switching it "ON", your profile will be visible to everyone.
        </span>
      </div>
    </div>
  );
}

export default ToggleProfile;
